<template>
  <div>
    <menu-pages-navbar class="mb-3" />
    <!-- Header -->
    <v-layout
      class="mt-5"
      wrap
    >
      <v-layout
        column
        align-center
      >
        <div class="subheading text-xs-center">
          {{ $t('menuQrCodeHint') }}
        </div>
        <!-- Loading Indicator -->
        <div
          v-if="loadingMenu"
          class="loading-indicator mt-5"
        >
          <v-progress-circular
            :size="50"
            indeterminate
            class="msr--text"
          />
        </div>
        <div
          v-if="!!menu && !menu.has_website_menu_template"
          class="warning--text text-xs-center mt-4"
          style="font-size: 20px"
        >
          {{ $t('menuQrCodeNoWebsiteTemplateYet_1') }}<br>
          {{ $t('menuQrCodeNoWebsiteTemplateYet_2') }}
        </div>
        <v-layout
          class="full-width mt-4"
          justify-center
          :style="{
            opacity: !!menu && menu.has_website_menu_template ? 1 : 0.2,
          }"
        >
          <v-img
            v-if="
              !!menu && menu.qrcode_example_image && $vuetify.breakpoint.smAndUp
            "
            max-width="1595"
            max-height="734"
            min-height="360"
            :aspect-ratio="
              $vuetify.breakpoint.width / $vuetify.breakpoint.height
            "
            cover
            :src="menu.qrcode_example_image"
          />
          <img
            v-if="!!menu && qrCodeBase64String && $vuetify.breakpoint.xs"
            :src="qrCodeBase64String"
            class="px-4"
            style="width: 100%; height: auto"
          >
        </v-layout>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import MenuPagesNavbar from '@/components/Menu/MenuPagesNavbar';

export default {
  components: {
    MenuPagesNavbar,
  },
  data() {
    return {
      loadingMenu: false,
      menu: null,
    };
  },
  computed: {
    menuId() {
      return this.$route.params.menuId;
    },
    qrCodeBase64String() {
      if (!this.menu || !this.menu.base64_qrcode_for_preview) {
        return '';
      }
      return (
        'data:image/png;charset=utf-8;base64,' +
        this.menu.base64_qrcode_for_preview
      );
    },
  },
  created() {
    this.fetchMenu({indicator: true});
  },
  methods: {
    fetchMenu({indicator = false} = {}) {
      if (indicator) {
        this.loadingMenu = true;
      }
      this.$api
        .retrieveMenu(this.menuId)
        .then((response) => {
          this.menu = response.data;
        })
        .finally(() => (this.loadingMenu = false));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/MenuQrCode.vue